<div *ngIf="title; else route" class="box">
    <div class="myForm">
        <div class="card">
            <h4 class="card-header">{{title}}</h4>
            <div class="card-body scroll">
                <form #reportForm="ngForm" (ngSubmit)="getRes()">
                    <p>
                        <mat-form-field appearance="outline" color="primary">
                            <mat-label>Client</mat-label>
                            <mat-select name="client" placeholder="Client" [(ngModel)]="reports.client" required>
                                <mat-option *ngFor="let item of clients" [value]="item.id">{{
                                    item.dname
                                    }}</mat-option>
                            </mat-select>
                            <mat-error>*Client is required</mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <mat-form-field appearance="outline" color="primary">
                            <mat-label>Report Type</mat-label>
                            <mat-select name="reportType" placeholder="Report Type" [(ngModel)]="reports.reportType"
                                (ngModelChange)="onReportType()" required>
                                <mat-option *ngFor="let item of reportTypes" [value]="item.id">
                                    {{item.dname}}</mat-option>
                            </mat-select>
                            <mat-error>*Report Type is required</mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <mat-form-field appearance="outline" color="primary">
                            <mat-label>Interval</mat-label>
                            <mat-select [disabled]="reports.reportType == 'yearly'" name="interval"
                                placeholder="Interval" [(ngModel)]="reports.interval" required>
                                <mat-option *ngFor="let item of intervals" [value]="item.id">{{
                                    item.dname
                                    }}</mat-option>
                            </mat-select>
                            <mat-error>*Interval is required</mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <mat-form-field style="width: 212px" appearance="outline">
                            <mat-label>Year</mat-label>
                            <input (click)="dp.open()" style="cursor: pointer;" matInput [matDatepicker]="dp"
                                [(formControl)]="date" [max]="maxDate" readonly required>
                            <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
                            <mat-datepicker #dp startView="multi-year" (yearSelected)="setYear($event, dp)">
                            </mat-datepicker>
                        </mat-form-field>
                    </p>
                    <p>
                        <mat-form-field appearance="outline" color="primary">
                            <mat-label>Comment</mat-label>
                            <textarea matInput [(ngModel)]="reports.comments" type="text" name="comment"
                                required></textarea>
                            <mat-error>*Comment is required</mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <button color="primary" class="button"
                            [disabled]="!reportForm.valid || buttonClicked || reports.year == null" type="submit"
                            mat-raised-button>
                            {{ buttonClicked ? "Downloading" : "Download" }}
                            <span>
                                <mat-icon *ngIf="buttonClicked">
                                    <mat-spinner diameter="25"></mat-spinner>
                                </mat-icon>
                            </span>
                        </button>
                    </p>
                </form>
            </div>
        </div>
    </div>
</div>
<ng-template #route>
    <router-outlet></router-outlet>
</ng-template>